import { render, staticRenderFns } from "./siderbar-item.vue?vue&type=template&id=629df9aa"
import script from "./siderbar-item.vue?vue&type=script&lang=js"
export * from "./siderbar-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports